import AccountType from '@app/constants/AccountType'
import { Flag } from 'types/src/common'
import { Lang } from '@app/types/src/Lang'
/*
0:非アクティブ
1:アクティブ
2:移行ユーザー（アカウント情報確認前）
*/
export const UserStatus = {
  InActive: 0,
  Active: 1,
  Import: 2,
} as const
export type UserStatusType = typeof UserStatus[keyof typeof UserStatus]

type AccountBase = {
  user_id: string
  name_1: string
  name_2: string
  furigana_1: string
  furigana_2: string
  email: string
  line_id: string
  tel: string
  user_status: UserStatusType
  temporary_password_flag: string
  language: Lang
}

export type NormalAccountResponse = {
  zip_code: string
  address_1: string
  address_2: string
  address_3: string
  address_4: string
  account_type: '1'
} & AccountBase
//
export type SalonAccountResponse = {
  corporate_name: string
  representative: string
  salon_name: string
  salon_name_furigana: string
  salon_url: string
  salon_tel: string
  salon_zipcode: string
  salon_address_1: string
  salon_address_2: string
  salon_address_3: string
  salon_address_4: string
  contract: Flag
  account_type: '2'
} & AccountBase

export interface UpdateEmailRequest {
  email: string
  password: string
}

export interface DeleteUserRequest {
  email: string
  password: string
}
